import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BusyService } from '../../shared/services/busy.service';
import { AdminSoundsService } from '../../shared/services/admin-sounds.service';
import { environment } from '../../../environments/environment';
import { AlertService } from '../../shared/services/alert.service';
import { ConfirmationService } from 'primeng/primeng';
import { FileUploadService } from '../../shared/core/file-upload.service';
import { UserFriendlyErrorService } from '../../shared/services/user-friendly-error.service';
import { AuthService } from '../../shared/services/auth.service';
import { RegionService } from '../../shared/services/region.service';
import { User } from '../../shared/models/User';

@Component({
  selector: 'app-admin-sounds',
  templateUrl: './admin-sounds.component.html',
  styleUrls: ['./admin-sounds.component.scss']
})
export class AdminSoundsComponent implements OnInit {
  busy = false;
  regionName = '';
  regionId = null;
  display = false;
  model = {
    sounds: [],
    selectedSound: null
  };
  editModel = {
    soundTitle: '',
    soundFilename: '',
    soundId: null
  };
  user: User;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private busyService: BusyService,
    private adminSounds: AdminSoundsService,
    private alertService: AlertService,
    private confirmationService: ConfirmationService,
    private fileUploadService: FileUploadService,
    private userFriendlyErrorService: UserFriendlyErrorService,
    private regionService: RegionService,
    private cd: ChangeDetectorRef
  ) {
    this.busyService.initHandler('adminSoundsCmp', busy => {
      this.busy = busy;
    });

    this.user = AuthService.currentUser();
    this.regionId = this.user.regionId;
    if (!this.user.isInRole(['sysadmin', 'superuser'])) {
      this.router.navigate(['/orgedit/' + this.user.organizationId]);
    } else {
      this.regionId = this.user.regionId;
    }
  }

  ngOnInit() {
    this.route.data.subscribe(data => {
      if (this.regionId > 0) {
        this.busyService
          .follow('adminSoundsCmp', this.regionService.get(this.regionId))
          .subscribe(r => {
            this.regionName = r.regionName;
          });
      }
    });
    this.loadData();
  }

  loadData(selectedSoundId?: number) {
    this.busyService
      .follow('adminSoundsCmp', this.adminSounds.all(this.regionId))
      .subscribe(sounds => {
        this.model.sounds = sounds;
        this.cd.detectChanges();
      });
  }

  editSound(sound) {
    this.editModel.soundTitle = sound.soundText;
    this.editModel.soundFilename = sound.soundFile;
    this.editModel.soundId = sound.soundId;
    this.display = true;
    this.cd.detectChanges();
  }

  editClose() {
    this.display = false;
    this.editModel.soundFilename = null;
    this.editModel.soundTitle = null;
    this.editModel.soundId = null;
    this.cd.detectChanges();
  }

  deleteRegionSound(sound) {
    this.confirmationService.confirm({
      message:
        'Are you sure that you want to delete "' + sound.soundText + '" file?',
      accept: () => {
        this.busyService
          .follow(
            'adminSoundsCmp',
            this.adminSounds.delete(this.regionId, sound.regionSoundFile)
          )
          .subscribe(result => {
            sound.regionSoundFile = null;
            // this.loadData();
          });
      }
    });
    this.cd.detectChanges();
  }

  onSendSound(sound) {
    const url =
      environment.api.baseUrl +
      environment.api.adminSounds.uploadSound
        .replace('{regionId}', this.regionId.toString())
        .replace('{filename}', this.editModel.soundFilename);

    if (sound.RecorderFlash) {
      this.busyService.busy('adminSoundsCmp');
      sound.RecorderFlash.upload({
        method: 'POST',
        url:
          url +
          '&access_token=' +
          encodeURIComponent(AuthService.currentUser().token),
        success: response => {
          this.busyService.alive('adminSoundsCmp');
          this.model.selectedSound = this.editModel.soundId;
          this.loadData();
        }
      });
    } else {

      const files = [];
      const audioFile = <any>new Blob([sound.blob], { type: 'audio/wav' });
      audioFile.name = this.editModel.soundFilename;
      files.push(<File>audioFile);

      this.busyService.busy('adminSoundsCmp');
      this.fileUploadService
        .upload(url, files)
        .then(r => {
          this.busyService.alive('adminSoundsCmp');
          this.model.selectedSound = this.editModel.soundId;
          this.loadData();
        })
        .catch(error => {
          this.alertService.showError(
            this.userFriendlyErrorService.getErrorMessage(url)
          );

          this.busyService.alive('adminSoundsCmp');
        });
    }
  }

  getToPaginatorLabel(dt) {
    if (dt.rows > dt.totalRecords) {
      return dt.totalRecords;
    } else {
      if (
        dt.rows + dt.first > dt.totalRecords
      ) {
        return dt.totalRecords;
      } else {
        return dt.first + dt.rows;
      }
    }
  }

  getSoundFileApi(filename) {
    const soundFilepath =
      environment.api.baseUrl +
      environment.api.adminSounds.play
        .replace('{regionId}', this.regionId.toString())
        .replace('{filename}', filename) +
      '&access_token=' +
      encodeURIComponent(this.user.token);
    return soundFilepath;
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/authorized/admin-sounds/admin-sounds.component.ts